import { ErrorBoundary } from "react-error-boundary";
import React, { useEffect } from "react";
import { ContainerErrorStyled, Text } from "../../configuration/appRoute.style";

const AppErrorHandling = (props: React.PropsWithChildren<any>) => {
    useEffect(() => {
        window.addEventListener("error", (event) => {
            //store.dispatch<any>(setErrorAction({ message: event.message }));
            //console.log(event);
            event.stopPropagation();
        });

        window.addEventListener(
            "unhandledrejection",
            (event: PromiseRejectionEvent) => {
                //store.dispatch<any>(setErrorAction({ message: event.reason.message }));
                //console.log(event);
            }
        );
    }, []);
    return (
        <ErrorBoundary
            FallbackComponent={ErrorFallback}
            onError={(error) => {
                // You can also log the error to an error reporting service like AppSignal
                // logErrorToMyService(error, errorInfo);
                console.log(error);
            }}
        >
            <>{props.children}</>
        </ErrorBoundary>
    );
};

const ErrorFallback = (error: any) => (
    <ContainerErrorStyled id="error-page">
        <Text variant="h2">Oops!</Text>
        <p>Sorry, an unexpected error has occurred.</p>
    </ContainerErrorStyled>
);

export default AppErrorHandling;
